export default "__VITE_ASSET__DaGdtHH5__"